<template>
  <label :for="id" class="def-checkbox">
    <input type="checkbox" class="def-checkbox__input" :checked="checked" :value="value" :name="name" :id="id" @change="updateInput" />
    <span class="def-checkbox__input-box"></span>
    <span class="def-checkbox__input-text" :class="{ 'def-checkbox__input-text--big': textBig }"
      v-html="text">
    </span>
    <p v-if="tip" class="def-checkbox__tip" v-html="tip"></p>
    <span v-if="error" class="def-checkbox__error">
      {{ error }}
    </span>
  </label>
</template>

<script>
export default {
  name: "DefCheckbox",
  $_veeValidate: {
    value() {
      return this.modelValue;
    }
  },
  model: {
    prop: "modelValue",
    event: "change"
  },
  props: {
    modelValue: {
      type: [Boolean, Array, String],
      default: false
    },
    id: {
      type: String,
      default: "input",
      required: true
    },
    text: {
      type: String,
      default: "Input",
      required: true
    },
    name: {
      type: String,
      default: "radio",
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      required: true
    },
    tip: String,
    textBig: {
      type: Boolean,
      default: false
    },
    error: {
      type: String
    },
    errorOnTop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      trueValue: true,
      falseValue: false
    };
  },
  computed: {
    checked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value);
      }
      return this.modelValue === this.trueValue;
    }
  },
  methods: {
    updateInput(event) {
      let isChecked = event.target.checked;
      if (this.modelValue instanceof Array) {
        let newValue = [...this.modelValue];
        if (isChecked) {
          newValue.push(this.value);
        } else {
          newValue.splice(newValue.indexOf(this.value), 1);
        }
        this.$emit("change", newValue);
      } else {
        this.$emit("change", isChecked ? this.trueValue : this.falseValue);
      }
    }
  }
};
</script>
<style scoped>
.def-checkbox__tip {
  color: #2e388e;
}
</style>
